import {
  API_BASE_URL,
  APP_ICORE_SERVICE,
  CMS_DOWNLOAD,
  CMS_EXPORT_REPORT_ESG,
  CMS_GET_SIOID,
  CMS_VIEW_DOCUMENT,
  VIEW_PHOTO_PROFILE_ISAFE,
} from "@/constants";
import axios from "axios";
import moment from "moment";
import { getUrlFile } from "./FileManager";
import util from "@/assets/js/util";
import { getSimperDynamic } from "./ESBE";
const url_sio_id = API_BASE_URL + CMS_GET_SIOID;
const url_download = API_BASE_URL + CMS_DOWNLOAD;
const url_view_document = API_BASE_URL + CMS_VIEW_DOCUMENT;
const url_download_excel_esg = API_BASE_URL + CMS_EXPORT_REPORT_ESG;
const url_get_photo = APP_ICORE_SERVICE + VIEW_PHOTO_PROFILE_ISAFE;

function getSessionUser() {
  return JSON.parse(localStorage.getItem("user_cms")) || null;
}

export const getSIOByIDContractor = async (contractor_id) => {
  const userData = getSessionUser();
  if (!contractor_id) {
    throw new Error("Kontraktor ID tidak valid");
  }
  if (!userData?.token) {
    throw new Error("Sesi login tidak ditemukan");
  }

  const result = await axios.get(url_sio_id + contractor_id, {
    headers: {
      role: userData.role == "kontraktor" ? userData.role : "isafe",
      Authorization: "Bearer " + userData.token,
      Accept: "application/json",
    },
  });

  return result.data;
};

export const downloadFile = async (filename, formatFilename = null) => {
  const res = await axios.get(url_download + filename, {
    responseType: "blob",
  });

  const dateNow = moment(new Date()).format("DDMMYYYY");

  const ext = filename.includes(".") ? filename.split(".").pop() : "pdf";

  const cleanFormatFilename = formatFilename
    ? formatFilename.replace(/\.(pdf|png|jpg|jpeg|xls|xlsx|doc|docx)$/i, "")
    : null;

  const baseFilename = filename.replace(/\.[^/.]+$/, "");

  const blob = new Blob([res.data], { type: "application/octet-stream" });
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);

  link.download = cleanFormatFilename
    ? `${cleanFormatFilename}.${ext}`
    : `${baseFilename}_${dateNow}.${ext}`;

  link.click();
};

export const showFile = (filename) => {
  window.open(url_view_document + filename, "_blank");
};

export const download = async (fileName) => {
  const res = await getUrlFile(fileName);

  const link = document.createElement("a");
  link.href = res.data;
  link.download = fileName;
  link.target = "_blank";

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const downloadReportESG = async (formatFilename, bodyJson) => {
  const userData = getSessionUser();
  const res = await axios.post(`${url_download_excel_esg}`, bodyJson, {
    headers: {
      role: userData.role == "kontraktor" ? userData.role : "isafe",
      Authorization: "Bearer " + userData.token,
      Accept: "application/json",
    },
    responseType: "blob",
  });

  let filename = formatFilename + ".xlsx";
  const contentDisposition = res.headers["content-disposition"];
  if (contentDisposition) {
    const match = contentDisposition.match(/filename="?(.+)"?/);
    if (match && match[1]) {
      filename = filename.replace(/[\s"']/g, "");
    }
  }

  const url = window.URL.createObjectURL(new Blob([res.data]));

  // Buat element link untuk download
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  link.remove();

  util.showInfo("File berhasil diunduh");

  // Hapus object URL dari memory
  window.URL.revokeObjectURL(url);
};

export const getFileIcon = (fileName) => {
  if (!fileName) return require("@/assets/icon/pdf.png");

  const ext = fileName.split(".").pop().toLowerCase();

  const iconMap = {
    pdf: require("@/assets/icon/pdf.png"),
    docx: require("@/assets/icon/docx.png"),
    xlsx: require("@/assets/icon/xlsx.png"),
    jpg: require("@/assets/icon/jpg.png"),
    jpeg: require("@/assets/icon/jpeg.png"),
    png: require("@/assets/icon/png.png"),
    pptx: require("@/assets/icon/pptx.png"),
    ppt: require("@/assets/icon/ppt.png"),
  };

  return iconMap[ext] || require("@/assets/icon/file.png");
};

export const previewPhoto = (isafeno) => {
  return `${url_get_photo}${isafeno}`;
};

/**
 * Checks whether user data should be refreshed from the backend.
 * Returns true if more than `intervalMs` has passed since the last refresh,
 * or if no refresh timestamp exists yet.
 * Defaults to 1 hour (3600000ms) if no interval is provided.
 */
export const shouldRefreshUserData = (intervalMs = 60000) => {
  const last = localStorage.getItem("lastRefreshTimestamp");
  if (!last) return true;
  return Date.now() - Number(last) >= intervalMs;
};

/**
 * Fetches latest user data (kontraktorName, department, id) from
 * getSimperDynamic and persists it to localStorage.
 * Returns the updated userData object so the caller can assign
 * it to its reactive state.
 */
export const refreshUserData = async (userData) => {
  if (!userData?.isafe_no) return userData;

  const res = await getSimperDynamic({
    isafe_number: userData.isafe_no,
    is_internal: false,
  });

  if (!res.simper || !res.simper.length) return userData;

  const simper = res.simper[0];
  // Strip PT/CV prefix and uppercase the company name
  const company = (simper.company || "")
    .replace(/^(PT|CV)\s*/i, "")
    .toUpperCase();

  userData.kontraktorName = company;
  userData.department = simper.department;
  if (simper.isafe_no) {
    userData.isafe_no = simper.isafe_no;
  }

  // Persist updated user data and record the refresh timestamp
  localStorage.setItem("user_cms", JSON.stringify(userData));
  localStorage.setItem("lastRefreshTimestamp", Date.now().toString());

  return userData;
};
